import { faSquarePlus } from "@elynx/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import i18n from "../../services/localization-service/i18n";
import { BaseActions, ActionMenuItem } from "../action-menu/ActionMenuItem";
import { IReferenceAlarmScheduleDTO, IReferenceAlarmSchemeDTO, IReferenceDTO, IReferenceNotificationListDTO } from "../../services/setpoint-administration-service/Models";
import { VirtualizedListItem } from "../virtualized-list/VirtualizedList";
import Enumerable from "linq";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { AddIcon } from "../action-menu/ActionMenuIcons";

export type AlarmSchemeItem = {
    setpoints: IeLynxObject[]
} & IReferenceAlarmSchemeDTO & 
VirtualizedListItem;

export type AlarmSchemesFormType = {

    alarmSchemes: AlarmSchemeItem[];
};

export enum AlarmSchemeListActionEnum  {
    Add = 'add',
    Edit = 'edit',
    Delete = 'delete',
    EditSetpoint = 'editsetpoint'
}

export type AlarmSchemeListActionItem = {
    action: AlarmSchemeListActionEnum | BaseActions | string
} & ActionMenuItem;

export const alarmSchemeActionItems: AlarmSchemeListActionItem[] = [{
    label: i18n.t("buttons.addAlarmScheme"),
    icon: AddIcon,
    action: AlarmSchemeListActionEnum.Add,
    order: 0
}];



const _updateAlarmSchemeForm = (schemeForm: IReferenceAlarmSchemeDTO,
    referenceData: IReferenceDTO) => {

    schemeForm.tiers.flatMap(v => v.notifications).forEach(v => {
        v.notificationListName = referenceData.notificationLists.find(x => x.id === v.notificationListID)?.name;
    });

    schemeForm.tiers.forEach(v => {

        v.schedules = [];
        Enumerable.from(v.notifications)
            .groupBy(x => x.scheduleID)
            .toArray()
            .forEach(x => {
                const scheduleID = x.key();
                const lists = x.toArray();

                lists.forEach(a => {
                    const tierNotification = referenceData.notificationLists.find(n => n.id === a.notificationListID);
                    a.notificationListName = tierNotification?.name;
                    a.organizationID = tierNotification?.organizationID;
                });

                const referenceSchedule = referenceData.alarmSchedules.find(a => a.id === scheduleID);

                if (referenceSchedule) {
                    const schedule :IReferenceAlarmScheduleDTO = {...referenceSchedule,

                        notificationLists: lists.map(n => {
                            return {
                                id: n.notificationListID,
                                name: n.notificationListName,
                                organizationID: n.organizationID
                            
                            } as IReferenceNotificationListDTO;
                        })
                    };

                    v.schedules.push(schedule);
                }
            });
    });
}



const AlarmSchemeListUtils = {
    
    filterAlarmSchemes: (data: IReferenceAlarmSchemeDTO[], 
        filter: string,
    ) : IReferenceAlarmSchemeDTO[] => {

    return data.filter(o => filter.trim() === '' ||
                            o.name.toLowerCase().indexOf(filter.trim().toLowerCase()) !== -1);
    },
    updateAlarmSchemeForm: (schemeForm: IReferenceAlarmSchemeDTO,
        referenceData: IReferenceDTO): void => {
            _updateAlarmSchemeForm(schemeForm, referenceData)
    }

}

export default AlarmSchemeListUtils;